import { Dialog } from '@cimplico/components';

type ChecklistItemActiveConfirmProps = {
    isOpen: boolean;
    onClose: () => void;
    handleActive: () => void;
};

function ChecklistItemActiveConfirm({ isOpen, onClose, handleActive }: ChecklistItemActiveConfirmProps): JSX.Element {
    return (
        <Dialog
            description="Do you want to mark this checklist item as Applicable?"
            onClose={onClose}
            onPrimaryActionClick={handleActive}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Confirm"
            secondaryAction="Cancel"
            title="Applicable"
            type="success"
        />
    );
}

export default ChecklistItemActiveConfirm;
